import { render, staticRenderFns } from "./ReminderListModal.vue?vue&type=template&id=af907346&"
import script from "./ReminderListModal.vue?vue&type=script&lang=ts&"
export * from "./ReminderListModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports